'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import { Film, Star, Shield, Zap } from 'lucide-react';

const benefits = [
  { icon: Film, label: 'Mbi 248 filma në katalog', sub: 'Të gjitha zhanret' },
  { icon: Star, label: 'Cilësi 4K Ultra HD', sub: 'Premium pa reklama' },
  { icon: Shield, label: 'Llogari e sigurt', sub: 'Histori dhe preferencat tuaja' },
  { icon: Zap, label: 'APK Android falas', sub: 'Shiko edhe offline' },
];

export default function AuthScreen() {
  const [tab, setTab] = useState<'login' | 'register'>('login');

  return (
    <div className="min-h-screen bg-background flex">
      {/* Left — Brand Panel */}
      <div className="hidden lg:flex flex-col justify-between w-[45%] xl:w-[42%] relative overflow-hidden p-10 xl:p-14">
        <div className="absolute inset-0 gradient-hero" />
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              'url(https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=900&q=60)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-background/20" />

        <div className="relative z-10">
          <Link href="/" className="flex items-center gap-2">
            <AppLogo size={40} />
            <span className="font-sans font-800 text-2xl text-foreground">
              Cine<span className="text-primary">Stream</span>
            </span>
          </Link>
        </div>

        <div className="relative z-10 space-y-8">
          <div>
            <h2 className="text-hero-md text-foreground mb-3">
              Platforma #1 e Filmave<br />
              <span className="text-primary">në Shqipëri</span>
            </h2>
            <p className="text-secondary-foreground text-sm leading-relaxed max-w-sm">
              Regjistrohu falas dhe fillo të shikosh filmat tënd të preferuar. Abono Premium
              për akses të plotë pa reklama.
            </p>
          </div>

          <div className="space-y-3">
            {benefits?.map((b) => (
              <div key={`benefit-${b?.label}`} className="flex items-center gap-3">
                <div className="w-9 h-9 bg-primary/15 rounded-lg flex items-center justify-center border border-primary/25 shrink-0">
                  <b.icon size={16} className="text-primary" />
                </div>
                <div>
                  <p className="text-sm font-600 text-foreground">{b?.label}</p>
                  <p className="text-xs text-muted-foreground">{b?.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative z-10">
          <p className="text-xs text-muted-foreground">
            © 2026 Dublime Al Shqip · Të gjitha të drejtat e rezervuara
          </p>
        </div>
      </div>

      {/* Right — Auth Form */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 lg:py-8 overflow-y-auto">
        {/* Mobile logo */}
        <Link href="/" className="flex items-center gap-2 mb-8 lg:hidden">
          <AppLogo size={36} />
          <span className="font-800 text-xl text-foreground">
            Cine<span className="text-primary">Stream</span>
          </span>
        </Link>

        <div className="w-full max-w-md">
          {/* Tabs */}
          <div className="flex bg-muted rounded-xl p-1 mb-8 border border-border">
            <button
              onClick={() => setTab('login')}
              className={`flex-1 py-2.5 rounded-lg text-sm font-700 transition-all duration-200 ${
                tab === 'login' ?'bg-card text-foreground shadow-sm border border-border' :'text-secondary-foreground hover:text-foreground'
              }`}
            >
              Hyr në Llogari
            </button>
            <button
              onClick={() => setTab('register')}
              className={`flex-1 py-2.5 rounded-lg text-sm font-700 transition-all duration-200 ${
                tab === 'register' ?'bg-card text-foreground shadow-sm border border-border' :'text-secondary-foreground hover:text-foreground'
              }`}
            >
              Regjistrohu
            </button>
          </div>

          {tab === 'login' ? (
            <LoginForm onSwitchToRegister={() => setTab('register')} />
          ) : (
            <RegisterForm onSwitchToLogin={() => setTab('login')} />
          )}
        </div>
      </div>
    </div>
  );
}